export default "__VITE_ASSET__RQfFm3I3__"